var swiper = new Swiper(".blog-list", {
  slidesPerView: 2,
  spaceBetween: 18,
  loop: false,
  navigation: {
    nextEl: ".blog-arrow-next",
    prevEl: ".blog-arrow-prev",
  },
  breakpoints: {
    1025: {
      slidesPerView: 3,
      spaceBetween: 48,
    },
   480: {
      slidesPerView: 2,
     spaceBetween: 18,
    },
  },
  });